module.exports = __webpack_public_path__ + "img/23.ac7c7e65.jpg";